import React, { useEffect, useState } from 'react'
import AppModal from '../../../components/organisms/CustomModal'
import PageTitle from 'components/atoms/PageTitle'
import FormInput from 'components/atoms/FormInput'
import { useLocation, useNavigate } from 'react-router-dom'
import searchIcon from '../../../assets/svg/search-normal.svg'
import Button from 'components/atoms/Button'
import { connect } from 'react-redux'
import { setUserLoggedIn } from 'redux/auth/auth.action'
import { SET_USER_LOGGED_IN, SET_USER_AUTH_DATA } from 'redux/auth/auth.type'
import { BASE_URL, getRequest, loggedUser_baseURL, postRequest, putRequest } from 'services/http'
import Alert from 'components/atoms/Alert';
import cancelIcon from '../../../assets/svg/close_x.svg'
import { useDispatch } from 'react-redux'

const EditSettlement = (props) => {
    const [dropdown, setDropdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingAcctData, setLoadingAcctData] = useState(false);

    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [mobile, setMobile] = useState('');
    const [errorStatus, setErrorStatus] = useState(false);
    const [showErr, setShowErr] = useState(false);

    const [selectInputVal, setSelectInputVal] = useState('');
    const [selectInputValErr, setSelectInputValErr] = useState('');

    const [bankList, setBankList] = useState<any>([]);

    const [selectedBank, setSelectedBank] = useState('');
    const [bvn, setBvn] = useState('');
    const [accountNum, setAccountNum] = useState('');
    const [accountName, setAccountName] = useState("");

    const [accountNumErr, setAccountNumErr] = useState('');
    const [bvnErr, setBvnErr] = useState('');
    const [pageNum, setPageNum] = useState(null);
    const [recordsPerPage] = useState(10);
    const dispatch = useDispatch();

    const inputNum = /^[0-9]*$/;
    const inputAlpha = /^[a-zA-Z ]*$/;
    const inputAlphaNum = /^[a-zA-Z0-9._-]*$/;

    const partnerCountry = props.countries?.find((c: { name: string; }) => c.name.toLowerCase() === props?.authData.country.toLowerCase());

    const fetchAccount = async () => {
        setLoadingAcctData(true);
        const headers = {
            "Content-Type": "application/json",
        }
        const body = {
            bankcode: selectedBank,
            accountnumber: accountNum
        }
        const res = await postRequest('https://pocket.seerbitapi.com/pocket/authenticate/name-enquiry', headers, body); // New name enquiry endpoint
        
        if (res?.data?.responseCode === "00") {
            setLoadingAcctData(false);
            setAccountName(res?.data.data.cutomername);
        } else {
            setLoadingAcctData(false);
        }

    }

    const fetchBanks = async () => {
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${props.bearerToken}`
        }
        const res = await getRequest(`${BASE_URL + loggedUser_baseURL}banks/${partnerCountry?.countryCode}?page=${pageNum === null ? 0 : pageNum}&size=${recordsPerPage}&p`, headers);

        if (res?.data.responseCode === '00') {
            setBankList(res?.data.data);
        } else {
            Alert('error', res?.data.message)
        }
    }

    useEffect(() => {
        fetchBanks();
    }, []);

    useEffect(() => {
        if (selectedBank && accountNum.length === 10) fetchAccount();
    }, [selectedBank, accountNum]);

    const handleSelect = (item) => {
        setSelectedBank(item.bank_nip_code)
        setSelectInputVal(item.bank_name)
        setDropdown(false)
    }

    const verifyKYCandSettlementInfo = async (requestData: any) => {
        setLoading(true)
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${props.bearerToken}`
        }
        const res = await putRequest(`${BASE_URL + loggedUser_baseURL}update`, headers, requestData);

        if (res?.data.responseCode === '00') {
            Alert('success', res?.data.message);
            setLoading(false);
            props.setShowModal(false);
            dispatch({
                type: SET_USER_AUTH_DATA,
                payload: {
                    settlement_account: requestData.settlement_account
                }
            })
        } else {
            setLoading(false);
            Alert('error', res?.data.message);
        }

    }

    const handleSubmit = e => {
        e.preventDefault();

        const requestData = {
            settlement_account: {
                payout_account_number: accountNum,
                payout_account_name: accountName,
                payout_bank_code: selectedBank,
                payout_bank_name: selectInputVal,
            }
        }

        verifyKYCandSettlementInfo(requestData);
    }

    const filteredData = bankList?.filter(item => {
        if (item.bank_name.toLowerCase().includes(selectInputVal.toLowerCase())) {
            return item;
        }
        else {
            return;
        }
    })

    return (
        <AppModal
            handleClose={() => props.setShowModal(false)}
            modalStyle="max-w-sm w-full mobile:w-4/5 bg-white min-h-[300px] h-fit z-30 my-auto mx-auto left-0 right-0 animate-slide_up rounded-lg p-8 shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all"
            contentStyle=""
            closeBtnStyle='hidden'
        >
            <form onSubmit={handleSubmit} className='flex flex-col gap-5'>
                <PageTitle
                    pageTitle='Edit Settlement Information'
                    pageTitleStyle='font-semibold !text-2xl tablet:!text-xl'
                    subTitle='Update your settlement information here.'
                    subTitleStyle='!text-sm leading-7 !text-Black2'
                    style='!mt-0 !gap-1'
                />
                
                <div className='flex flex-col gap-5'>
                    <div className={`w-full relative`}>
                        <FormInput
                            type="text"
                            placeholder={`${(selectInputVal === '' || props.authData?.settlement_account?.payout_bank_name === undefined) && "Enter bank name"}`}
                            style={` w-full relative z-[15]`}
                            inputStyle={`border border-transparent text-Black2 w-full bg-white`}
                            label='Select Bank'
                            labelStyle='font-semibold text-sm leading-6 text-Black2'
                            value={selectInputVal}
                            onChange={e => {
                                setSelectInputVal(e.target.value)

                                if (e.target.value.length >= 1) {
                                    setDropdown(true);
                                } else {
                                    setDropdown(false);
                                }
                            }}
                            img={searchIcon}
                            imgStyle='w-4 h-4'
                        />
                        {dropdown &&
                            <div className={`min-w-[150px] max-w-3/5 w-fit max-h-[200px] overflow-scroll flex flex-col gap-0 absolute z-10 right-0 p-1 bg-white rounded-md shadow-[0_8px_30px_rgb(0,0,0,0.12)] h-fit animate-slide_down2`}>
                                {filteredData?.length === 0
                                    ? <span className='p-2 text-sm font-normal leading-6 rounded-md cursor-default text-Primary hover:bg-BackDrop_d_xs'>
                                        Not found
                                    </span>

                                    : filteredData?.map((item, i) => (
                                        <span key={i} onClick={() => handleSelect(item)} className='p-2 text-sm font-normal leading-6 rounded-md cursor-pointer text-Black2 hover:bg-BackDrop_d_xs'>
                                            {item.bank_name}
                                        </span>
                                    ))
                                }
                            </div>
                        }
                    </div>

                    <FormInput
                        type={'text'}
                        name='account_number'
                        placeholder={`${(accountNum === '' || props.authData?.settlement_account?.payout_account_number === undefined) && "Enter account number"}`}
                        style='w-full'
                        inputStyle="border border-transparent text-Black2"
                        label="Account Number"
                        labelStyle="font-semibold text-sm leading-6 text-Black2"
                        value={accountNum}
                        validationErr={showErr && accountNumErr}
                        onChange={e => {

                            if (inputNum.test(e.target.value)) setAccountNum(e.target.value);

                            if (e.target.value.length !== 10) {
                                setAccountNumErr('Invalid Account number');
                                setShowErr(true);
                            }

                            setTimeout(() => {
                                setShowErr(false);
                            }, 3000);
                        }}
                    />

                    <div className=''>
                        <p className="mb-2 text-sm font-semibold leading-6 text-Black2">Account name</p>
                        <div className={`rounded-lg px-3 py-2 text-sm bg-SecondaryAccent5 border border-SecondaryAccent5 text-gray-600`}>
                            {loadingAcctData ? (
                                <div className="flex w-full gap-3 animate-pulse">
                                    <div className={`rounded h-5 w-3/6 bg-gray-300`}></div>
                                    <div className={`rounded h-5 w-2/6 bg-gray-300`}></div>
                                </div>
                            ) : (
                                <span className={`${accountName === '' && 'text-gray-400'}`}>
                                    {props.authData?.settlement_account?.payout_account_name !== undefined 
                                        ?   props.authData?.settlement_account?.payout_account_name
                                        :   accountName 
                                            ?   <strong>{accountName}</strong>
                                            :   'This field is auto generated'
                                    }
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                <div className='flex justify-between'>
                    <Button
                        btnType='button'
                        btnText='Close'
                        btnStyle='text-Primary bg-none border-none'
                        onClick={() => props.setShowModal(false)}
                    />

                    <Button
                        btnType="submit"
                        btnText={
                            loading ? (
                                "Loading..."
                            ) : (
                                "Submit"
                            )
                        }
                        btnStyle={`${accountName === "" ? "cursor-not-allowed" : ""
                            } bg-black text-white px-6 py-3 w-fit`}
                        disabled={accountName === ""}
                        onClick={() => { }}
                    />
                </div>
            </form>
        </AppModal>
    )
}

const mapStateToProps = state => ({
    bearerToken: state.auth.user_authData?.token.token,
    authData: state.auth.user_authData,
    user_loggedIn: state.auth.user_loggedIn,
    countries: state.app.countries
})

const mapDispatchToProps = dispatch => ({
    setUserLoggedIn: (data: boolean) => dispatch(setUserLoggedIn(data)),
})


export default connect(mapStateToProps, mapDispatchToProps)(EditSettlement);





